import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_generation } from '@/hooks/store/use_slices';
import { LOCAL__ui_set_boolean } from '@/state/ui/_base/LOCAL__ui_set_boolean';
import { LOCAL__ui_drag_and_drop_set_hovered_graph_field } from '@/state/ui/drag_and_drop/LOCAL__ui_drag_and_drop_set_hovered_graph_field';
import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';

export function WATCHER_IMAGES__drag_and_drop_external() {
  /*
   * STORE
   */
  const dispatch = use_dispatch();
  const { generation_current } = use_slice_generation(['generation_current']);

  /*
   * EFFECTS
   */
  use_effect(() => {
    window.addEventListener('dragenter', on_drag_enter_window);
    window.addEventListener('dragover', on_drag_over_window);
    window.addEventListener('dragleave', on_drag_leave);
    window.addEventListener('drop', on_drop);

    return () => {
      window.removeEventListener('dragenter', on_drag_enter_window);
      window.removeEventListener('dragover', on_drag_over_window);
      window.removeEventListener('dragleave', on_drag_leave);
      window.removeEventListener('drop', on_drop);
    };
  }, [generation_current]);
  /*
   * EVENTS
   */

  function on_drag_enter_window(e: DragEvent): void {
    if (e.dataTransfer?.types.includes('Files')) {
      dispatch(LOCAL__ui_set_boolean({ key: 'drag_and_drop__image_external_zones_show', value: true }));
    }
  }

  function on_drag_over_window(e: DragEvent): void {
    e.preventDefault();

    try_detect_over_component_graph_field(e);
  }

  function on_drag_leave(e: DragEvent): void {
    const { clientX, clientY } = e;

    if (clientX <= 0 || clientY <= 0 || clientX >= window.innerWidth || clientY >= window.innerHeight) {
      reset_to_default();
    }
  }

  function on_drop(e: DragEvent): void {
    e.preventDefault();

    reset_to_default();
  }

  /*
   * METHODS
   */

  function reset_to_default() {
    dispatch(LOCAL__ui_set_boolean({ key: 'drag_and_drop__image_external_zones_show', value: false }));

    dispatch(LOCAL__ui_drag_and_drop_set_hovered_graph_field());
  }

  function try_detect_over_component_graph_field(e: DragEvent) {
    let { clientX, clientY } = e;

    const element: Element | null = document.elementFromPoint(clientX, clientY);
    const field_id: string = element?.closest('[data-drag-and-drop-zone-graph-field]')?.getAttribute('data-drag-and-drop-zone-graph-field') ?? '';

    let field = FIELD__base.CREATE_STUB();

    if (field_id != '') {
      let fields_all = generation_current.tool.graph.fields__get_map();

      field = fields_all.get_or_assert(field_id);
    }

    dispatch(LOCAL__ui_drag_and_drop_set_hovered_graph_field(field));
  }

  return null;
}
